import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import template from './talenyaView.html';
import Logger from '../../../shared/logger';
import './style.scss';
import UtilsService from '../../../services/utilsService';
import {EMPLOYER_ROLE, TALENT_EXPERT_ROLE} from '../../../services/permissionService';

export class TalenyaComponent {
    /* @ngInject */
    constructor(
        AuthService,
        RecruiterService,
        EmployerService,
        OfficeService,
        $cookies,
        $state,
        $translate,
        RouteService,
        NotificationService,
        WebAppRouteService,
        CampaignService,
        $filter,
        $timeout,
    ) {
        UtilsService.cookiesOverride($cookies);
        const talenyaCtrl = this;
        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        const userData = UtilsService.parseJSON($cookies.get('userData'));

        const isTalenyaUser = userData?.roles?.indexOf('TALENYA') >= 0;
        talenyaCtrl.officeGroups = [];
        talenyaCtrl.loading = false;

        const groupVisibilityState = {};
        const employersPerOfficeLimitState = {};
        talenyaCtrl.employersPerOffice = {};
        talenyaCtrl.MAX_EMPLOYERS_TO_DISPLAY = RouteService.getSystemPreference('appMenuMaxEmployersPerOfficeQuantity') || 5;
        talenyaCtrl.employerNameSearchValue = '';

        talenyaCtrl.officeGroups.forEach((group) => {
            groupVisibilityState[group] = !isTalenyaUser;
        });

        talenyaCtrl.setGroupVisibility = (group, isVisible) => {
            groupVisibilityState[group] = isVisible ?? !groupVisibilityState[group];
        };

        talenyaCtrl.closeAllEmployerOffices = () => {
            for (const office in talenyaCtrl.employersPerOffice) {
                talenyaCtrl.setGroupVisibility(office, false);
            }
        };

        talenyaCtrl.isGroupVisible = (group) => groupVisibilityState[group];

        talenyaCtrl.setEmployersPerOfficeLimitState = () => {
            for (const officeName in talenyaCtrl.employersPerOffice) {
                const employersQty = talenyaCtrl.employersPerOffice[officeName].length;
                employersPerOfficeLimitState[officeName] = employersQty > talenyaCtrl.MAX_EMPLOYERS_TO_DISPLAY;
            }
        };

        talenyaCtrl.isGroupLimited = (office) => employersPerOfficeLimitState[office];

        talenyaCtrl.toggleLimitState = (office) => {
            employersPerOfficeLimitState[office] = !employersPerOfficeLimitState[office];
        };

        talenyaCtrl.clearEmployerNameSearch = () => {
            talenyaCtrl.employerNameSearchValue = '';
            talenyaCtrl.employersFilteredByName = talenyaCtrl.employers;
            talenyaCtrl.employersPerOffice = talenyaCtrl.getEmployersPerOffice(talenyaCtrl.employers);
            talenyaCtrl.setEmployersPerOfficeLimitState();
            talenyaCtrl.closeAllEmployerOffices();
        };

        talenyaCtrl.getEmployersPerOffice = (employers) => _.reduce(employers, (acc, employer) => {
            const officeName = employer.office;
            acc[officeName] = acc[officeName] ? [...acc[officeName], employer] : [employer];
            return acc;
        }, {});

        talenyaCtrl.init = function () {
            OfficeService.getOffices()
                .then((response) => {
                    const { result: officeGroups = talenyaCtrl.officeGroups } = response || {};
                    talenyaCtrl.officeGroups = officeGroups;
                    talenyaCtrl.officeGroups.forEach((group) => {
                        groupVisibilityState[group] = !isTalenyaUser;
                    });
                })
                .catch((error) => Logger.error(error));

            talenyaCtrl.searchData = {
                type: 'talenya',
            };
        };

        if (!isTalenyaUser) {
            window.location.hash = '#/default';
            return;
        }

        talenyaCtrl.toggleMenu = function () {
            $('.background')
                .toggle();
            $('.navbar-nav-menu')
                .toggle();
            talenyaCtrl.showMenu = !talenyaCtrl.showMenu;

            if (!talenyaCtrl.showMenu) {
                talenyaCtrl.clearEmployerNameSearch();
            }
        };

        talenyaCtrl.closeMenu = function () {
            if (talenyaCtrl.showMenu == true) {
                talenyaCtrl.toggleMenu();
            }
        };

        talenyaCtrl.userPicture = RouteService.getUserData('picture');

        if (userPrefs.entityId) {
            talenyaCtrl.recruiterUser = true;
            talenyaCtrl.recruiterId = userPrefs.entityId;
        }

        talenyaCtrl.tftMainLogoUrl = RouteService.getThemeSettings('tftMainLogoUrl') || '';

        talenyaCtrl.usersAllowedToCreateRecruiters = RouteService.getSystemPreference('usersAllowedToCreateRecruiters');
        talenyaCtrl.usersAllowedToEditSystemCampaigns = RouteService.getSystemPreference('usersAllowedToEditSystemCampaigns');

        talenyaCtrl.userEmail = RouteService.getUserData('email');
        talenyaCtrl.isUserEnabledToAddRecruiter = _.includes(talenyaCtrl.usersAllowedToCreateRecruiters, talenyaCtrl.userEmail);
        talenyaCtrl.isUserEnabledToEditSystemCampaigns = _.includes(talenyaCtrl.usersAllowedToEditSystemCampaigns, talenyaCtrl.userEmail);

        if (talenyaCtrl.isUserEnabledToEditSystemCampaigns) {
            CampaignService.getSystemCampaignsForAllowedUsers().then(async ({ result }) => {
                talenyaCtrl.user = await RouteService.getUser(talenyaCtrl.userEmail);

                talenyaCtrl.employerId = _.get(talenyaCtrl.user, 'result.userPrefs.lastSelectedEmployerId', '');
                talenyaCtrl.systemDefaultCampaignId = _.get(_.find(result, (c) => c.role === TALENT_EXPERT_ROLE), '_id', null);
                talenyaCtrl.employerDefaultCampaignId = _.get(_.find(result, (c) => c.role === EMPLOYER_ROLE), '_id', null);

                talenyaCtrl.openSystemDefaultCampaign = talenyaCtrl.systemDefaultCampaignId && talenyaCtrl.employerId
                    ? () => {
                        WebAppRouteService.goToSystemCampaignPage(
                            { campaignId: talenyaCtrl.systemDefaultCampaignId, employerId: talenyaCtrl.employerId },
                        );
                    } : null;

                talenyaCtrl.openEmployerDefaultCampaign = talenyaCtrl.employerDefaultCampaignId && talenyaCtrl.employerId
                    ? () => {
                        WebAppRouteService.goToSystemCampaignPage(
                            { campaignId: talenyaCtrl.employerDefaultCampaignId, employerId: talenyaCtrl.employerId },
                        );
                    } : null;
            }).catch((error) => Logger.error(error));
        }

        RecruiterService.getAllRecruitersForMenu()
            .then((response) => {
                talenyaCtrl.recruiters = response.result.filter((recruiter) => recruiter.fullName && recruiter.fullName.trim());
                talenyaCtrl.currentUsers = _.remove(talenyaCtrl.recruiters, (recruiter) => {
                    // eslint-disable-next-line no-underscore-dangle
                    if (userPrefs.entityId === recruiter._id) {
                        return true;
                    }
                    if (recruiter.contact) {
                        for (let i = 0; i < recruiter.contact.email.length; i++) {
                            if (recruiter.contact.email[i].value === userData?.email) {
                                return true;
                            }
                        }
                    }
                    return false;
                });
            })
            .catch((error) => Logger.error(error));

        EmployerService.getAllEmployersForMenu()
            .then(({ result: employers }) => {
                talenyaCtrl.employers = _.orderBy(employers, ['settings.isResellerPartner', 'name'], ['desc', 'asc']);
                talenyaCtrl.employersFilteredByName = employers;
                talenyaCtrl.employersPerOffice = talenyaCtrl.getEmployersPerOffice(talenyaCtrl.employers);
                talenyaCtrl.clearEmployerNameSearch();
                talenyaCtrl.setEmployersPerOfficeLimitState();
            });

        talenyaCtrl.onEmployerFilterChange = function () {
            talenyaCtrl.employersFilteredByName = talenyaCtrl.employers.filter(
                (e) => _.includes(_.toLower(e.name), _.toLower(talenyaCtrl.employerNameSearchValue)),
            );

            talenyaCtrl.employersPerOffice = talenyaCtrl.getEmployersPerOffice(talenyaCtrl.employersFilteredByName);
            talenyaCtrl.setEmployersPerOfficeLimitState();

            for (const group in groupVisibilityState) {
                groupVisibilityState[group] = !_.isEmpty(talenyaCtrl.employerNameSearchValue);
            }
        };

        talenyaCtrl.refreshLists = async function () {
            await Promise.all([
                RouteService.getRefreshMetaData(),
                RouteService.refreshTalentCache(),
            ])
                .then(() => NotificationService.success('List refreshed'))
                .catch((error) => Logger.error(error));
        };

        talenyaCtrl.startLoading = () => $timeout(() => {
            talenyaCtrl.loading = true;
        });

        talenyaCtrl.stopLoading = () => $timeout(() => {
            talenyaCtrl.loading = false;
        });

        talenyaCtrl.logout = function () {
            AuthService.logout();
        };

        talenyaCtrl.blockSessions = async () => {
            const msg = $filter('translate')('BLOCK_ACTIVE_SESSIONS_CONFIRMATION_MODAL');
            if ((window.confirm(msg))) {
                talenyaCtrl.startLoading();
                try {
                    await RouteService.blockActiveSessions();
                    await AuthService.logout();
                    NotificationService.success('BLOCK_ACTIVE_SESSIONS_SUCCESS');
                } catch (err) {
                    Logger.error(err);
                    NotificationService.error('BLOCK_ACTIVE_SESSIONS_ERROR');
                    talenyaCtrl.stopLoading();
                } finally {
                    talenyaCtrl.stopLoading();
                }
            }
        };

        talenyaCtrl.clearAllCaches = async () => {
            talenyaCtrl.startLoading();
            try {
                await RouteService.clearAllCaches();
                NotificationService.success('CLEAR_ALL_CACHES_SUCCESS');
            } catch (err) {
                Logger.error(err);
                NotificationService.error('CLEAR_ALL_CACHES_ERROR');
            } finally {
                talenyaCtrl.stopLoading();
            }
        };

        talenyaCtrl.createNewEmployer = function () {
            $state.go('talenya.createNewEmployer');
        };

        talenyaCtrl.createNewRecruiter = function () {
            $state.go('talenya.createNewRecruiter');
        };

        talenyaCtrl.goPositionsPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId,
            });
        };

        talenyaCtrl.init();
    }
}

export const TalenyaComponentConfiguration = {
    template,
    controller: TalenyaComponent,
    controllerAs: 'talenyaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('talenyaComponent', TalenyaComponentConfiguration);
